import { useQuizContext } from '../context';

export function useQuestions() {
  const ctx = useQuizContext();

  return ctx.quiz.questions;
}
